import * as z from "zod/v4";

const StationStep_ = z.object({ flowId: z.string(), stepId: z.string() });
export const StationStep: z.ZodType<StationStep> = StationStep_;
export interface StationStep extends z.infer<typeof StationStep_> {}

export const createWorkOrderStation = {
  name: "createWorkOrderStation" as const,
  input: z.object({
    name: z.string(),
    locationId: z.string().nullable(),
    steps: z.array(StationStep),
  }),
  output: z.object({ stationId: z.string() }),
};
